import React from 'react'
import { useApplicationQueues, useApplicationModals } from '@adc/ui-adc'

// WHY: this hook provides an extra layer of functionality to allow
// pdp to call the authentication modal, as well as the queue
// management without needing to repeat so much logic all over PDP
// or refactoring so many class based components into functions,
// which introduces extra risks and potentially breaks unit testing
// TODO: Move to hooks library?
export const useModalFeatures = () => {
  const queues = useApplicationQueues()
  const modals = useApplicationModals()
  const pushAuthQueueItem = queues.postAuthentication.push
  const pushOnboardingQueueItem = queues.postOnboarding.push
  const toggleAuthModal = (authInitialActive = 'login') => {
    modals.open('authentication', { authInitialActive })
  }

  return { pushAuthQueueItem, pushOnboardingQueueItem, toggleAuthModal }
}

export const withModalHooks = WrappedComponent => originalProps => {
  const { pushAuthQueueItem, pushOnboardingQueueItem, toggleAuthModal } =
    useModalFeatures()
  return (
    <WrappedComponent
      {...originalProps}
      pushAuthQueueItem={pushAuthQueueItem}
      pushOnboardingQueueItem={pushOnboardingQueueItem}
      toggleAuthModal={toggleAuthModal}
    />
  )
}
